const contactLabel = contact => {
  if (contact) {
    return   contact.first_name || contact.middle_name || contact.last_name
    ? `${contact.first_name ? `${contact.first_name} ` : ''}${
        contact.middle_name ? `${contact.middle_name} ` : ''
      }${contact.last_name ? `${contact.last_name} ` : ''}`
    : null
  }
  return null
}

export default (obj) => {
  const { personType, itemType, item, businessName, accountName, contact } = obj

  const endLogic = () => {
    if (businessName) return businessName
    if (accountName) return accountName
    return 'System'
  }

  if (itemType === 'email') {
    // for email, direction is listed under "email",
    // but others have that under "conversationItem"
    if (item.direction === 'outbound') {
      if (item.from_name) return item.from_name
      if (item.from) return item.from
      if (item.from_id) return item.from_id
      return endLogic()
    }

    if (item.direction === 'inbound') {
      if (contactLabel(contact)) return contactLabel(contact)
      if (item.from) return item.from
      return 'Unknown'
    }
  }

  if (itemType === 'sms') {
    if (item.direction === 'outbound') {
      if (item.sms.originator) return item.sms.originator
      if (item.sms.originator_id !== '_system') return item.sms.originator_id
      if (item.originator_number) return item.originator_number
      return endLogic()
    }

    if (item.direction === 'inbound') {
      if (contactLabel(contact)) return contactLabel(contact)
      if (item.sms.originator_number) return item.sms.originator_number
      return 'Unknown'
    }
  }

  if (itemType === 'call') {
    if (item.direction === 'outbound') {
      if (personType === 'sender') {
        if (item.call.originator) return item.call.originator
        if (item.call.originator_id) return item.call.originator_id
        if (item.call.originator_number) return item.call.originator_number
        return endLogic()
      }

      if (personType === 'recipient') {
        if (contactLabel(contact)) return contactLabel(contact)
        if (item.call.recipient_number) return item.call.recipient_number
        return 'Unknown'
      }
    }

    if (item.direction === 'inbound') {
      if (personType === 'sender') {
        if (contactLabel(contact)) return contactLabel(contact)
        if (item.call.originator_number) return item.call.originator_number
        return 'Unknown'
      }
      
      if (personType === 'recipient') {
        if (item.call.recipient) return item.call.recipient
        if (item.call.recipient_id) return item.call.recipient_id
        if (item.call.recipient_number) return item.call.recipient_number
        return endLogic()
      }
    }
  }

  return 'Unknown'
}